"use strict";

define('rs/modals/sponsor.finder/sponsor.finder.controller',['rs/modals/table.finder/table.finder.controller', 'rs/models/sponsor'], function (RSFinderController, RSSponsorModel) {
  var SponsorFinderController = RSFinderController.extend({
    defaultTitle: 'Sponsor Finder',
    columns: [{
      name: 'name',
      displayName: 'Name',
      type: 'String',
      width: '55%'
    }, {
      name: 'categoryDescription',
      displayName: 'Category',
      type: 'String',
      width: '20%'
    }, {
      namespace: 'preferredPhone.number',
      displayName: 'Phone',
      type: 'String',
      width: '18%'
    }, {
      icon: 'plus',
      className: 'btn-add-member',
      width: '7%',
      sortable: false
    }],
    generateDisplayName: function generateDisplayName(item) {
      return item.name;
    },
    _requestTableItems: function _requestTableItems(searchQuery) {
      return RSSponsorModel.requestSponsorList(searchQuery);
    },
    processFilter: function processFilter(items, filter) {
      if (filter.field) {
        return _.filter(items, function (item) {
          if (item.item[filter.field] == filter.value) {
            return true;
          }
        });
      }
      return items;
    }
  });
  return SponsorFinderController;
});

